module.exports = __webpack_public_path__ + "static/media/controls_3000.decc6f6c.ico";